<template>
  <el-table-column
    prop="id"
    label="#"
    show-overflow-tooltip
    fixed
    min-width="50"
  >
    <template slot-scope="scope">
      {{ scope.row.id }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'id',
  };
</script>
